const { makeStyles } = require('@material-ui/core');

export const useStyles = makeStyles((theme) => ({
  content: {
    backgroundColor: theme.palette.grey[100],
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    padding: theme.spacing(1),
    position: 'fixed',
    width: '100%',
    zIndex: theme.zIndex.appBar,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
  },
  body: {
    marginTop: 56,
    flex: 1,
    display: 'flex',
    overflow: 'hidden',
  },
  desktopPanelLeft: {
    width: 320,
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    borderRight: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
    },
  },
  desktopPanelRight: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  mobilePanelFull: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  threadListContainer: {
    flex: 1,
    overflowY: 'auto',
  },
  messageThreadContainer: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
    },
  },
  emptyStateContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.secondary,
  },
  bubbleDispatcher: {
    alignSelf: 'flex-end',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: theme.spacing(2, 2, 0, 2),
    padding: theme.spacing(1, 1.5),
    maxWidth: '70%',
    marginBottom: theme.spacing(0.5),
  },
  bubbleDriver: {
    alignSelf: 'flex-start',
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.text.primary,
    borderRadius: theme.spacing(2, 2, 2, 0),
    padding: theme.spacing(1, 1.5),
    maxWidth: '70%',
    marginBottom: theme.spacing(0.5),
  },
  bubbleMeta: {
    fontSize: '0.7rem',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  bubbleMetaRight: {
    textAlign: 'right',
  },
  composeBox: {
    display: 'flex',
    alignItems: 'flex-end',
    padding: theme.spacing(1, 2),
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    gap: theme.spacing(1),
  },
  composeTextField: {
    flex: 1,
  },
  pushLabel: {
    fontSize: '0.7rem',
    color: theme.palette.text.secondary,
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  threadListItem: {
    cursor: 'pointer',
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  threadListItemSelected: {
    backgroundColor: `${theme.palette.primary.main}14`,
  },
  threadListItemName: {
    minWidth: 0,
    marginRight: theme.spacing(1),
    fontWeight: 600,
    fontSize: '0.95rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  threadListItemPreview: {
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  threadListItemTime: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    textAlign: 'right',
  },
  unreadDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    flexShrink: 0,
  },
  panelTitle: {
    padding: theme.spacing(1.5, 2),
    fontWeight: 600,
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
    borderBottom: `1px solid ${theme.palette.divider}`,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  backButton: {
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));
